import { render, staticRenderFns } from "./follow-up-record-common.vue?vue&type=template&id=14dd68cb&scoped=true"
import script from "./follow-up-record-common.vue?vue&type=script&lang=ts"
export * from "./follow-up-record-common.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14dd68cb",
  null
  
)

export default component.exports